type BasicApi<T> = {
  code: number;
  data: T;
  msg?: string;
};
export type PartialRecord<K extends keyof any, T> = {
  [P in K]?: T;
};
export type TApi<T> = BasicApi<T>;
export type TPromiseApi<T> = Promise<BasicApi<T>>;

export enum ESwitch {
  CLOSE,
  OPEN,
}

// 通用的返回值，用于Select选择器的列表
export type TOption = {
  id: string;
  name: string;
};
